exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resource--2JP5z {\n  padding: 10px;\n  margin: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  line-height: 15px;\n  width: 130px;\n  height: 130px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 0.25rem;\n  color: #526f46;\n  transition: background-color 0.15s ease-in-out;\n}\n\n.resource--2JP5z:hover {\n  text-decoration: none;\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.resource--2JP5z img {\n  height: 35px;\n}\n\n.resource--2JP5z span {\n  margin-top: 10px;\n}\n\n", ""]);

// exports
exports.locals = {
	"resource": "resource--2JP5z"
};